<template>
  <v-btn 
    class="mainButton"
    :class="{'isLoading': isLoading}"
    depressed
    :disabled='disabled || isLoading'
    @click="$emit('click')">
      <div class="d-flex" :class="{hidden: isLoading}">
        <slot></slot>
      </div> 
      <loader class="loader" v-if="isLoading"/>
  </v-btn>
</template>

<script>
  import {VBtn} from 'vuetify/lib'
  import Loader from '@/components/Loader'
  export default {
    name: 'ConfirmButton',
    components: { VBtn, Loader },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
.loader {
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>